/**
 * 用户相关
 * */

import $axios from '@/api/axios'

// 登录
export function login(data) {
    return $axios({
        url: '/login/login',
        method: 'post',
        data
    })
}

// 获取验证码
export function getCaptcha(data) {
    return $axios({
        url: '/login/getCaptcha',
        method: 'get',
        params: {...data}
    })
}

